import { render, staticRenderFns } from "./LayoutContentRendererLeft.vue?vue&type=template&id=bc5e078c&"
import script from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js&"
export * from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5e078c')) {
      api.createRecord('bc5e078c', component.options)
    } else {
      api.reload('bc5e078c', component.options)
    }
    module.hot.accept("./LayoutContentRendererLeft.vue?vue&type=template&id=bc5e078c&", function () {
      api.rerender('bc5e078c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/layout-content-renderer/LayoutContentRendererLeft.vue"
export default component.exports